export default "__VITE_ASSET__EoYP07O7__"